import React from "react";
import { AiOutlineUser } from "react-icons/ai";
import TextInput from "../../components/TextInput";
import Title from "../../components/Title";
import Button from "../../components/Button";

const LoginRegister = ({
  page,
  logo,
  titlecolor,
  inputlabelcolor,
  inputiconcolor,
  inputerrorcolor,
  gradientcolor,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="text-center mb-4">
          <img src={logo} className="w-25" />
        </div>
        <Title title="Sign up" color={titlecolor} />
        <form name="form" className="form" onSubmit={handleSubmit}>
          <div className="form-group">
            <TextInput
              page={page}
              label="Enter Phone Number or Email"
              name="emailOrPhone"
              icon={<AiOutlineUser color={inputlabelcolor} />}
              placeholder="Email or Phone number"
              value={""}
              onChange={""}
              disabled={false}
              error={false}
              inputlabelcolor={inputiconcolor}
              inputiconcolor={inputiconcolor}
              inputerrorcolor={inputerrorcolor}
            />
          </div>
          <div className="form-group my-4">
            <Button title="Sign up" disabled={false} color={gradientcolor} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginRegister;
